import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  ListSubheader,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  colors,
  styled,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  useModuleDelete,
  useModuleInfo,
  useModuleUpdate,
  useUpdateModulefiles,
} from "../../../intake/intakeQueries";
import { ReactChild, ReactFragment, ReactPortal } from "react";
import { Key } from "react";
import { ErrorMessage } from "../../../common/ErrorMessage";
import {
  AddAPhotoRounded,
  Delete,
  DeleteRounded,
  Edit,
  Warning,
} from "@material-ui/icons";
import { LabelButton } from "../../../intake/components/unitIntake/Unitprintbutton";
import { formatDate } from "../../../common/formatDate";
import { Field, Form, Formik } from "formik";
import moment from "moment";
import { toast } from "react-toastify";
import { DatePicker } from "formik-material-ui-pickers";
import React, { useState, useRef } from "react";
import { useFetchContext } from "../../../common/FetchContext";
import { useCrateUpdate } from "../../../intake/intakeMutations";
import { DropzoneArea } from "material-ui-dropzone";
import { getTheme } from "../../../common/getLocalTheme";
import PrintIcon from "@material-ui/icons/Print";
import { PDFDocument, PDFPage, PDFArray, PDFDict, PDFName } from "pdf-lib";
import printJS from "print-js";
import { getBaseUrl } from "../../../common/util";

// ---------------------------------------------------------------------------
// Page-level de-duplication helpers for "Print All"
// ---------------------------------------------------------------------------

const fnv1a = (bytes: Uint8Array): string => {
  let hash = 0x811c9dc5;
  for (let i = 0; i < bytes.length; i++) {
    hash ^= bytes[i];
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16);
};

const streamBytes = (obj: any): Uint8Array | null =>
  obj && obj.contents instanceof Uint8Array ? obj.contents : null;

const getPageSignature = (pdfDoc: PDFDocument, page: PDFPage): string => {
  const ctx = pdfDoc.context;
  const parts: string[] = [];

  const { width, height } = page.getSize();
  parts.push(`${Math.round(width)}x${Math.round(height)}`);

  try {
    const contents: any = (page.node as any).Contents();
    const streams =
      contents instanceof PDFArray
        ? contents.asArray().map((ref: any) => ctx.lookup(ref))
        : [contents];

    streams.forEach((stream: any) => {
      const bytes = streamBytes(stream);
      if (bytes) parts.push(`c:${bytes.length}:${fnv1a(bytes)}`);
    });
  } catch (e) {
    // ignore - fall back to whatever else we can hash
  }

  try {
    const resources: any = (page.node as any).Resources();
    const xObjects = resources?.lookup(PDFName.of("XObject"), PDFDict);
    if (xObjects) {
      xObjects.entries().forEach(([name, ref]: any) => {
        const bytes = streamBytes(ctx.lookup(ref));
        if (bytes)
          parts.push(`x:${name.asString()}:${bytes.length}:${fnv1a(bytes)}`);
      });
    }
  } catch (e) {
    // ignore
  }

  return parts.join("|");
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "primary",
  padding: theme.spacing(2),
  fontSize: 14,
  borderRadius: 10,
  color: "secodary",
}));

var moduleInfo;

export const ModuleInfo = () => {
  const { authAxios } = useFetchContext();

  const { id } = useParams() as {
    id: string;
  };

  const [apiLoading, setApiLoading] = React.useState(false);

  const [open, setOpen] = React.useState(false);
  const [openImage, setOpenImage] = React.useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);

  const [image, setImage] = React.useState("");
  const [files, setFiles] = React.useState([]);
  const [uploading, setUploading] = useState(false);
  const [labelName, setLabel] = React.useState("");
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleDelete = () => {
    setDeleteDialogOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenImage(false);
    setDeleteDialogOpen(false);
  };

  const handleImage = async (item: any) => {
    console.log(item);
    setImage(item.id);
    setLabel(item.label_name);
    fileInputRef.current?.click();
  };

  function goto(): void {
    history.push(`/operations_management/module_intake/intake/upload ${id}`);
  }

  const { mutateAsync: mutate } = useUpdateModulefiles();

  const { mutateAsync: mutateParam } = useModuleUpdate();

  const { mutateAsync: mutateDelete } = useModuleDelete();

  const ProceedDelete = async () => {
    setApiLoading(true);

    try {
      await mutateDelete({
        authAxios,
        id: id,
      });
      setApiLoading(false);
      setDeleteDialogOpen(false);

      toast("Module Deleted!");

      window.location.reload();
    } catch (error) {
      console.error("failed:", error);
      toast.error("Module delete faild!");
    } finally {
      setApiLoading(false);
    }
  };

  const handleFileChange = async (uploadedFiles: any) => {
    setFiles(uploadedFiles);
    console.log(uploadedFiles);
    setUploading(true); // Start uploading
    try {
      if (uploadedFiles.length > 0) {
        for (let file of uploadedFiles) {
          setOpenImage(false);
          await mutate({
            authAxios,
            file: file,
            id: id,
            image_id: image,
            label: labelName,
          });
        }
        toast("Image uploaded successfully!");
      }
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Image uploaded faild!");
      setOpenImage(false);
    } finally {
      setUploading(false); // End uploading
      window.location.reload();
    }
  };

  const history = useHistory();

  const {
    error: errorData,
    data: moduleData,
    isLoading: isloding,
    isError: isErrorData,
  } = useModuleInfo(id);

  if (isloding) {
    return (
      <Backdrop open={isloding}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  if (isErrorData) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          width: "100vw",
          textAlign: "center",
        }}
      >
        <Typography variant="h4" color="error" gutterBottom>
          Module Deleted
        </Typography>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          The module you are looking for has been deleted or is no longer
          available.
        </Typography>
      </Box>
    );
  }
  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles && uploadedFiles.length > 0) {
      handleFileChange(Array.from(uploadedFiles));
    }
  };

  const handlePrintAll = async () => {
    try {
      setApiLoading(true);

      // Get all print buttons from the grid
      const printButtons = Array.from(
        document.querySelectorAll<HTMLButtonElement>(".pdf-print-btn"),
      );

      // Get unit ID and PDF URL
      const allPdfUrls = printButtons
        .map((button) => ({
          unitID: button.getAttribute("data-unit-id"),
          url: button.getAttribute("data-pdf-url"),
        }))
        .filter((item): item is { unitID: string; url: string } =>
          Boolean(item.unitID && item.url),
        );

      // Remove duplicate unit_id
      const uniquePdfUrls = Array.from(
        new Map(allPdfUrls.map((item) => [item.unitID, item])).values(),
      );

      if (uniquePdfUrls.length === 0) {
        toast.warning("No unique labels available.");
        return;
      }

      toast.info(`Fetching ${uniquePdfUrls.length} unique labels...`);

      // Create one PDF
      const mergedPdf = await PDFDocument.create();

      let successCount = 0;

      // Fetch only unique unit IDs
      for (const item of uniquePdfUrls) {
        try {
          const response = await authAxios.get(item.url, {
            responseType: "arraybuffer",
          });

          const pdfBytes = response.data;

          if (!pdfBytes || pdfBytes.byteLength === 0) {
            console.warn(`Empty PDF response for unit ${item.unitID}`);
            continue;
          }

          // Check PDF header
          const header = new TextDecoder().decode(
            new Uint8Array(pdfBytes).slice(0, 5),
          );

          if (header !== "%PDF-") {
            console.warn(`Invalid PDF for unit ${item.unitID}`);
            continue;
          }

          // Load individual PDF
          const individualPdf = await PDFDocument.load(pdfBytes);

          const seenPageSignatures = new Set<string>();

          // Keep only the first copy of each distinct page of this unit's label
          const keepIndices: number[] = [];

          individualPdf.getPages().forEach((page, pageIndex) => {
            const signature = getPageSignature(individualPdf, page);

            if (seenPageSignatures.has(signature)) {
              return;
            }

            seenPageSignatures.add(signature);
            keepIndices.push(pageIndex);
          });

          if (keepIndices.length === 0) {
            continue;
          }

          // Copy only the unique pages into merged PDF
          const copiedPages = await mergedPdf.copyPages(
            individualPdf,
            keepIndices,
          );

          copiedPages.forEach((page) => {
            mergedPdf.addPage(page);
          });

          successCount++;
        } catch (error) {
          console.error(`Failed to process unit ${item.unitID}:`, error);
        }
      }

      if (mergedPdf.getPageCount() === 0) {
        toast.error("No valid PDF labels received.");
        return;
      }

      // Save merged PDF
      const mergedPdfBytes = await mergedPdf.save();

      // Fix Uint8Array<ArrayBufferLike> TypeScript issue
      const arrayBuffer = new ArrayBuffer(mergedPdfBytes.byteLength);

      new Uint8Array(arrayBuffer).set(mergedPdfBytes);

      const blob = new Blob([arrayBuffer], {
        type: "application/pdf",
      });

      const blobUrl = URL.createObjectURL(blob);

      // Print one combined PDF
      printJS({
        printable: blobUrl,
        type: "pdf",
      });

      toast.success(`${successCount} unique labels merged successfully`);

      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 60000);
    } catch (error) {
      console.error("Print all failed:", error);
      toast.error("Failed to generate merged PDF.");
    } finally {
      setApiLoading(false);
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }} padding={2}>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={6} alignItems="flex-start" direction="column">
          <Box padding={2}>
            <Typography variant="h4" color="primary">
              Intake Info
              <IconButton disabled={getTheme()} onClick={handleClickOpen}>
                <Edit color="primary" />
              </IconButton>
              <IconButton disabled={getTheme()} onClick={handleDelete}>
                <Delete color="primary" />
              </IconButton>
            </Typography>
          </Box>
          <Item>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <label>
                  Location:{" "}
                  {moduleData.module_intake_details &&
                    moduleData.module_intake_details.location}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Intake Date:{" "}
                  {moduleData.module_intake_details &&
                    formatDate(moduleData.module_intake_details.intake_date)}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Received Date:{" "}
                  {moduleData.module_intake_details &&
                    formatDate(moduleData.module_intake_details.received_date)}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Intake Id : {moduleData.module_intake_details.moduleintake_id}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>Lot Id: {moduleData.module_intake_details.lot_id}</label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Project Number:{" "}
                  {moduleData.module_intake_details.project_number}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Customer Name:{" "}
                  {moduleData.module_intake_details.customer_name}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Manufacturer Name:{" "}
                  {moduleData.module_intake_details.manufacturer_name}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>WorkOrder: {moduleData.module_intake_details.bom}</label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Crate Name: {moduleData.module_intake_details.crate_name}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>Unit Requied: {moduleData.expected_unit_count}</label>
              </Grid>
            </Grid>
          </Item>
        </Grid>
        <Grid item xs={6} alignItems="flex-start" direction="column">
          <Box padding={2.5}>
            <Typography variant="h4" color="primary">
              Intake Details
            </Typography>
          </Box>
          <Item>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <label>Total No. of Modules : 12</label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Module Type:{" "}
                  {moduleData.module_intake_details.module_type &&
                    moduleData.module_intake_details.module_type}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Cell Type:{" "}
                  {moduleData.module_property_details.module_technology_name}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Module Dimensions (mm):{" "}
                  {moduleData.module_property_details.module_width}X
                  {moduleData.module_property_details.module_height}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Mpp: {moduleData.module_property_details.nameplate_pmax}
                </label>
              </Grid>
              <Grid item xs={6}>
                <label>Voc: {moduleData.module_property_details.voc}</label>
              </Grid>
              <Grid item xs={6}>
                <label>Isc: {moduleData.module_property_details.isc}</label>
              </Grid>
              <Grid item xs={6}>
                <label>Vmp: {moduleData.module_property_details.vmp}</label>
              </Grid>
              <Grid item xs={6}>
                <label>Imp: {moduleData.module_property_details.imp}</label>
              </Grid>
              <Grid item xs={6}>
                <label>
                  Rated Voltage:{" "}
                  {moduleData.module_property_details.system_voltage}
                </label>
              </Grid>
              <Grid item xs={6}>
                <Box padding={1.2}></Box>
              </Grid>
              <Grid item xs={6}>
                <label> </label>
              </Grid>
            </Grid>
          </Item>
        </Grid>
      </Grid>

      <Box padding={3} sx={{ flexGrow: 1 }}>
        <Box padding={2}>
          <Typography variant="h4" color="primary">
            Pannel Details
          </Typography>
        </Box>
        <TableContainer component={Paper}>
          <Table>
            <TableHead style={{ backgroundColor: "green" }}>
              <TableRow>
                <TableCell
                  align="center"
                  style={{ color: "white", fontWeight: 600 }}
                >
                  Serial Number
                </TableCell>
                <TableCell
                  align="center"
                  style={{ color: "white", fontWeight: 600 }}
                >
                  Module Type
                </TableCell>
                <TableCell
                  align="center"
                  style={{ color: "white", fontWeight: 600 }}
                >
                  Test Type
                </TableCell>
                <TableCell
                  align="center"
                  style={{ color: "white", fontWeight: 600 }}
                >
                  Status
                </TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    onClick={handlePrintAll}
                    disabled={apiLoading}
                    size="small"
                    startIcon={
                      apiLoading ? (
                        <CircularProgress size={16} color="inherit" />
                      ) : (
                        <PrintIcon fontSize="small" />
                      )
                    }
                    style={{
                      borderRadius: "6px",
                      fontWeight: "bold",
                      textTransform: "none",
                      backgroundColor: "white",
                      color: "green",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                    disableElevation={apiLoading}
                  >
                    {apiLoading ? "Generating..." : "Print All"}
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from(
                new Map(
                  moduleData.scanned_pannel_details.map(
                    (item: any, index: number) => {
                      // Clean the serial number to guarantee exact matches
                      const uniqueKey = item.serial_number
                        ? String(item.serial_number).trim().toUpperCase()
                        : `missing-serial-${index}`;

                      return [uniqueKey, item];
                    },
                  ),
                ).values(),
              ).map((item: any, index: number) => (
                <TableRow key={item.unit_id || index}>
                  <TableCell align="center">
                    {item.serial_number && item.serial_number}
                  </TableCell>
                  <TableCell align="center">
                    {item.module_type && item.module_type}
                  </TableCell>
                  <TableCell align="center">
                    {item.test_sequence_name && item.test_sequence_name}
                  </TableCell>
                  <TableCell align="center">
                    {item.status ? "Active" : "InActive"}
                  </TableCell>
                  <TableCell align="center">
                    {item.unit_id ? (
                      <LabelButton unitID={item.unit_id} />
                    ) : (
                      "Print not Available"
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box padding={3}>
        <Box padding={2}>
          <Typography variant="h4" color="primary">
            Images{" "}
            <IconButton disabled={getTheme()} onClick={() => goto()}>
              <AddAPhotoRounded color="primary"></AddAPhotoRounded>
            </IconButton>
          </Typography>
        </Box>
        <div>
          {moduleData?.categories_of_module_images?.map((category: any) => (
            <div key={category.label_name}>
              <h2>{category.label_name}</h2>
              <h4>
                Description:{" "}
                {category.images[0]?.notes ? category.images[0].notes : "NA"}
              </h4>
              <ImageList cols={5}>
                {category.images.map((item: any) => (
                  <ImageListItem key={item.id}>
                    <img
                      srcSet={`${item.image_path}?w=248&fit=crop&auto=format&dpr=2 2x`}
                      src={`${item.image_path}?w=248&fit=crop&auto=format`}
                      loading="lazy"
                      alt={item.label_name}
                    />

                    <ImageListItemBar
                      actionIcon={
                        <IconButton
                          disabled={getTheme()}
                          onClick={() => handleImage(item)}
                        >
                          <Edit color="primary" />
                          {uploading ? (
                            image === item.id ? (
                              <CircularProgress size={24} />
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </IconButton>
                      }
                    />
                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ display: "none" }}
                      accept="image/*,.pdf"
                      onChange={handleImageUpload}
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </div>
          ))}
        </div>
      </Box>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit Module Info</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{
              intake_date: moduleData.module_intake_details.intake_date,
              received_date: moduleData.module_intake_details.received_date,
            }}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                var date = "";
                if (values.intake_date == null) {
                  date = "";
                } else {
                  date = moment(values.intake_date).format("YYYY-MM-DD");
                }
                await mutateParam({
                  authAxios,
                  moduleintake: id,
                  moduleintake_date: values.intake_date,
                  received_date: values.received_date,
                });

                setSubmitting(false);

                handleClose();
                toast.success("Project was succesfully changed");
                window.location.reload();
              } catch (error) {
                toast.error("error data");
              }
            }}
          >
            {({ errors, touched, submitForm, resetForm }) => (
              <Form>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                >
                  <Grid item sm={12}>
                    <Field
                      id="intake_date"
                      name="intake_date"
                      component={DatePicker}
                      format="YYYY-MM-DD HH:MM"
                      style={{ marginBottom: 32 }}
                      label="Intake Date"
                      inputVariant="outlined"
                      data-testid="intake_date"
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <Field
                      id="received_date"
                      name="received_date"
                      component={DatePicker}
                      format="YYYY-MM-DD HH:MM"
                      style={{ marginBottom: 32 }}
                      label="Received Date"
                      inputVariant="outlined"
                      data-testid="received_date"
                      fullWidth
                    />
                  </Grid>

                  <Button
                    data-testid="submitCrateId"
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={getTheme()}
                    onClick={submitForm}
                  >
                    Submit
                  </Button>
                </Grid>
              </Form>
            )}
          </Formik>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openImage} onClose={handleClose}>
        <DialogTitle>Image Upload</DialogTitle>
        <DialogContent>
          <DropzoneArea
            acceptedFiles={["image/*", ".pdf"]}
            filesLimit={1}
            maxFileSize={12000000}
            data-testid="fileUploadCrate"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={handleClose}>
        <DialogTitle style={{ color: "red" }}>
          Module Delete Confirmation{" "}
          <Icon>
            <Warning></Warning>
          </Icon>
        </DialogTitle>

        <DialogContent>
          <Typography
            variant="body1"
            style={{ color: "red", fontWeight: "bold", textAlign: "center" }}
          >
            Are you sure you want to delete this intake record? This action is
            irreversible, and all related data will be permanently removed.
            Associated serial numbers mentioned below are also removed.
          </Typography>

          <div
            style={{
              color: "red",
              fontWeight: "bold",
              textAlign: "center",
              alignContent: "center",
              justifyItems: "center",
              marginTop: "15px",
            }}
          >
            {moduleData.scanned_pannel_details.map(
              (item: { serial_number: any }, index: number) => (
                <div key={index}>
                  {/* Display the count */}
                  {index + 1}.{/* Display the serial number */}
                  {item.serial_number && (
                    <>
                      {item.serial_number}
                      <br />
                    </>
                  )}
                </div>
              ),
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={ProceedDelete} color="primary">
            Proceed
          </Button>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
